export default __webpack_public_path__ + "locales/si/PeopleTranslations.json?hash=8c37c490349326a957d7533ad01bb00e";